import HttpClient from "./api";

class SubAffiliationApi extends HttpClient {
    public constructor() {
        super();
    }

    getSubAffiliationReport(year: number, month: number) {
        return this.doGet(`/api/v3/reports/subaffiliation/all?year=${year}&month=${month}`);
    }

    getCurrentMonthSubAffiliationCommission() {
        return this.doGet('/api/v3/reports/subaffiliation/current/month');
    }
}

export const subAffiliationApi = new SubAffiliationApi();